/* eslint-disable @typescript-eslint/no-empty-function */
import dayjs from 'dayjs'
import { pick, reduce, assoc, keys } from 'ramda'

export const noop = () => {}

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

export const isUnixDate = (val?: string) =>
  val && val.match(/^\d{13}$/g) && dayjs(parseInt(val, 10)).isValid()

export const isDate = (val?: string) => {
  if (!val) {
    return false
  }

  if (val.match(/^\d{13}$/g)) {
    return dayjs(parseInt(val, 10)).isValid()
  }

  return dayjs(val).isValid()
}

export const formatDate = (val: string) => {
  const date = isUnixDate(val) ? parseInt(val, 10) : val
  return dayjs(date).format('MM/DD/YYYY')
}

type BuiltObject<
  Original extends object,
  Names extends keyof Original = keyof Original,
  Map extends Record<string, keyof Original> = Record<string, keyof Original>
> = Pick<Original, Exclude<Names, Map[keyof Map]>> & {
  [K in Map[keyof Map]]: Original[K]
}

export const buildObject = <
  Original extends object,
  Names extends Array<keyof Original> = Array<keyof Original>,
  Map extends Record<string, keyof Original> = Record<string, keyof Original>
>(
  original: Original,
  names?: Names,
  map?: Map
) => {
  if (!names) return original

  const newObject = pick(names, original)

  if (!map) return newObject as BuiltObject<Original, Names[number]>

  return reduce(
    (acc, key) => assoc(map[key] || key, newObject[key], acc),
    {},
    keys(newObject)
  ) as BuiltObject<Original, Names[number], Map>
}
